import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import security from "../../services/security.js";
import messaging from "../../services/messagingv2.js";

class GoogleplacesController {
  constructor(
    $http,
    $scope,
    $localStorage,
    $state,
    AuthService,
    SecurityService,
    Messagingv2Service,
    $rootScope,
    $location,
    TrackingService,
    $timeout
  ) {
    this.name = "googleplaces";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$tracking = TrackingService;
    this.$security = SecurityService;
    this.$messagingv2 = Messagingv2Service;
    this.currentUser = this.$auth.getUserData();
    this.$location = $location;
    this.$timeout = $timeout;
    this.address_ui = {
      is_error: true,
      is_error_message: null,
    };
    this.address = null;

    var _this = this;

    _this.SetAddressErrorPickupListener = _this.$rootScope.$on("SetAddressErrorPickup", function ($event, params) {
      _this.set_address_error_pickup(params.page);
    });

    _this.SetAddressErrorListener = _this.$rootScope.$on("SetAddressError", function ($event, params) {
      _this.set_address_error(params.page);
    });

    _this.SetDropOffAddressCloneListener = _this.$rootScope.$on("SetDropOffAddressClone", function ($event, params) {
      console.log("params drop off");
      console.dir(params);
      _this.$timeout(function () {
        _this.address = params;
      }, 300);
    });

    _this.SetPickUpAddressCloneListener = _this.$rootScope.$on("SetPickUpAddressClone", function ($event, params) {
      _this.address = params;
    });

    _this.$scope.$on("$destroy", _this.SetAddressErrorListener);
    _this.$scope.$on("$destroy", _this.SetAddressErrorPickupListener);
    _this.$scope.$on("$destroy", _this.SetDropOffAddressCloneListener);
    _this.$scope.$on("$destroy", _this.SetPickUpAddressCloneListener);
  }

  set_address_error_pickup() {
    var _this = this;
    _this.address_ui.error = true;
    _this.address_ui.error_msg = "A pickup address is required.";
  }

  set_address_error(page) {
    var _this = this;
    _this.address_ui.error = true;
    _this.address_ui.error_msg = "A dropoff address is required.";
  }

  address_change() {
    var _this = this;
    if (typeof _this.address === "object") {
      _this.address_ui.error = false;
      _this.$timeout(function () {
        _this.$rootScope.$emit("SetAddress", {
          address: _this.address,
        });
      });
    }
  }

  pickup_address_selected() {
    var _this = this;
    console.log(".pickup_address_selected()");
    console.dir(_this.address);
  }

  validate_address() {
    var _this = this;
  }

  address_clicked() {
    var _this = this;
  }
}

GoogleplacesController.$inject = [
  "$http",
  "$scope",
  "$localStorage",
  "$state",
  "auth",
  "security",
  "messagingv2",
  "$rootScope",
  "$location",
  "tracking",
  "$timeout",
];

export default GoogleplacesController;



// WEBPACK FOOTER //
// ./client/app/common/googleplaces/googleplaces.controller.js